import React, { useState } from "react";
import css from "../../style/visionStyle.module.css";
import BottomSheet from "./BottomSheet";
import { MdKeyboardArrowUp } from "react-icons/md";

const BookingTotal = ({ estimatePricing, type, distanceInKm , isBottomSheetOpen = false , setIsBottomSheetOpen }) => {


  function formatWorkTime(workTime) {
    if (workTime === null || workTime === undefined || workTime === "") return "-";

    const format = (decimalHour) => {
      if (decimalHour === null || decimalHour === undefined || isNaN(decimalHour)) return "-";
      const totalMinutes = Math.round(Math.abs(decimalHour) * 60);

      if (totalMinutes < 60) {
        return `${totalMinutes.toString().padStart(2, "0")} min`;
      }

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      if (minutes === 0) return `${hours} hr`;

      return `${hours} hr ${minutes.toString().padStart(2, "0")} min`;
    };

    // handle numeric input
    if (typeof workTime === "number") return format(workTime);

    // coerce to string and safely split ranges like "1.5-2"
    const parts = String(workTime)
      .split("-")
      .map(s => s.trim())
      .filter(Boolean)
      .map(Number)
      .filter(n => !isNaN(n));

    if (parts.length === 0) return "-";
    if (parts.length === 1) return format(parts[0]);

    return `${format(parts[0])} - ${format(parts[1])}`;
  }
 

  // const handleOpenBottomSheet = () => {
  //   setIsBottomSheetOpen(true);
  // };

  const handleCloseBottomSheet = () => {
    setIsBottomSheetOpen(false);
  };

  const handleReturnVal = (val, symbol) => {
    return val ? symbol + val : "-";
  };

  const renderDeliveryBreakdown = () => (
    <>
      <div className={css.costItem}>
        <span>Base Fare:</span>
        <span>{handleReturnVal(estimatePricing?.baseFare, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Distance ({distanceInKm}km):</span>
        <span>{handleReturnVal(estimatePricing?.totalDistance, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Labour:</span>
        <span>{handleReturnVal(estimatePricing?.labourSurcharge, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Extra moover:</span>
        <span>{handleReturnVal(estimatePricing?.delivery_ExtraMooverCharge, "$")}</span>
      </div>
      <div className={css.costItem} style={{ fontWeight: "700" }}>
        <span>Subtotal:</span>
        <span>{handleReturnVal(estimatePricing?.totalChargeBTax, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Service Fee:</span>
        <span>{handleReturnVal(estimatePricing?.totalServiceFee, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>GST ({estimatePricing?.totalTaxGstpstrate}%):</span>
        <span>{handleReturnVal(estimatePricing?.gstandPst, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Discount:</span>
        <span>{handleReturnVal(estimatePricing?.discount, "")}</span>
      </div>
      <div
        className={css.costItem}
        style={{ fontWeight: "700", fontSize: "1.1em" }}
      >
        <span>Total:</span>
        <span>{handleReturnVal(estimatePricing?.totalCharge, "$")}</span>
      </div>
      <div className={css.estimationNote}>
        This estimate is based on the information provided. The final total will
        be calculated based on the total work-time needed to complete the job.
      </div>
    </>
  );

  const renderMovingBreakdown = () => (
    <>
      <div className={css.costItem}>
        <span>Hourly rate:</span>
        <span>{handleReturnVal(estimatePricing?.hourlyRate, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Est. work time (hrs):</span>
        <span>{formatWorkTime(estimatePricing?.workTime, "")}</span>
      </div>
      <div className={css.costItem}>
        <span>Travel time (hrs):</span>
        <span>{formatWorkTime(estimatePricing?.travelTime, "")}</span>
      </div>
      <div className={css.costItem} style={{ fontWeight: "700" }}>
        <span>Est. subtotal:</span>
        <span>{handleReturnVal(estimatePricing?.totalChargeBTax, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Service Fee:</span>
        <span>{handleReturnVal(estimatePricing?.totalServiceFee, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>GST ({estimatePricing?.totalTaxGstpstrate}%):</span>
        <span>{handleReturnVal(estimatePricing?.gstandPst, "$")}</span>
      </div>
      <div className={css.costItem}>
        <span>Discount:</span>
        <span>{handleReturnVal(estimatePricing?.discount, "")}</span>
      </div>
      <div
        className={css.costItem}
        style={{ fontWeight: "700", fontSize: "1.1em" }}
      >
        <span>Est. total:</span>
        <span>{handleReturnVal(estimatePricing?.totalCharge, "$")}</span>
      </div>
      <div className={css.estimationNote}>
        This estimate is based on the information provided. The final total will
        be calculated based on the total work-time needed to complete the job.
      </div>
    </>
  );

  return (
    <>
      {/* <div className={css?.vsionCostMd} onClick={handleOpenBottomSheet}>
        <div className={css?.visionCostWrapper}>
          <div className={css?.visionCostLabel}>
            <span>Estimated</span>
            <span>Total</span>
          </div>
          <div className={css?.visionCostTagContainer}>
            <div className={css?.visionCostTag}>
              <span className={css.amount}>{total?.totalCharge || "0.00"}</span>
              <span className={css.currencyCode}>CAD</span>
            </div>
            <MdKeyboardArrowUp
              className={`${css.chevronIcon} ${
                isBottomSheetOpen ? css.chevronRotated : ""
              }`}
              size={24}
            />
          </div>
        </div>
      </div> */}

      <BottomSheet isOpen={isBottomSheetOpen} onClose={handleCloseBottomSheet}>
        <div className={css.bottomSheetContent}>
          <h3>Cost Breakdown</h3>
          <div className={css.costBreakdown}>
            {["Delivery", "Business"].includes(type)
              ? renderDeliveryBreakdown()
              : renderMovingBreakdown()}
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default BookingTotal;
